import { isEmpty } from "lodash-es";
import React from "react";
import { getAddSizeUnit } from "../../utils/size";
import { classnames } from "../../utils/text";
import DataComponent from "../DataComponent";
import Loading from "../Loading";
import NoData from "../NoData/NoData";
import CardList from "./CardList";
import RankList from "./RankList";
import PerfectScrollbar from "react-perfect-scrollbar";

const CustomList = ({
  list = [],
  fields = [],
  isLoading,
  isTable = true,
  height,
}) => {
  return (
    <div
      className="custom-list"
      style={{
        ...(height ? { height: getAddSizeUnit(height) } : {}),
      }}
    >
      <PerfectScrollbar>
        {isLoading ? (
          <Loading />
        ) : isEmpty(list) ? (
          <NoData />
        ) : isTable ? (
          <div className="display-table">
            {list.map((data, idx) => (
              <div className="display-table-row" key={idx}>
                {fields.map((field, i) => (
                  <div
                    className={`display-table-cell ${classnames(
                      field.className
                    )}`}
                    key={i}
                    style={{
                      ...(field.width
                        ? { width: getAddSizeUnit(field.width) }
                        : {}),
                    }}
                  >
                    <DataComponent field={field} data={data} />
                  </div>
                ))}
              </div>
            ))}
          </div>
        ) : (
          list.map((data, idx) => (
            <div className="custom-list-box" key={idx}>
              {fields.map((field, i) => (
                <div
                  className={`${classnames(field.className)}`}
                  key={i}
                  style={{
                    ...(field.width
                      ? { width: getAddSizeUnit(field.width) }
                      : {}),
                  }}
                >
                  <DataComponent field={field} data={data} />
                </div>
              ))}
            </div>
          ))
        )}
      </PerfectScrollbar>
    </div>
  );
};

export { CustomList, CardList, RankList };
export default CustomList;
